import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-subtle bg-canvas mt-24">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-14 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-2">
          <div className="font-serif font-bold text-5xl md:text-6xl">Retreat Travel<span className="text-moss">.</span></div>
          <div className="font-serif font-bold italic text-lg md:text-xl text-[#E63946] mt-2">Discover Travel That Transforms Lives.</div>
          <p className="text-muted2 mt-3 max-w-md text-sm leading-relaxed">
            Journeys that combine yoga, meaningful work, community activity, and generous sharing. For those who travel to become, not just to see.
          </p>
        </div>
        <div>
          <div className="overline mb-3">Explore</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/discover" className="hover:text-moss">All Experiences</Link></li>
            <li><Link to="/discover?pillar=spirituality" className="hover:text-moss">Yoga & Meditation</Link></li>
            <li><Link to="/discover?pillar=work" className="hover:text-moss">Remote Work</Link></li>
            <li><Link to="/discover?pillar=activities" className="hover:text-moss">Adventure</Link></li>
          </ul>
        </div>
        <div>
          <div className="overline mb-3">Host</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/for-hosts" className="hover:text-moss">List your space</Link></li>
            <li><Link to="/register" className="hover:text-moss">Join as host</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-subtle text-xs py-6 text-center text-muted2">
        © {new Date().getFullYear()} Retreat Travel — Transformational travel, made kindly.
      </div>
    </footer>
  );
}
